import type { IItemOrderRequest, IItem } from '@/types/IOrder'

export const formatOrderItem = (orderItem: IItemOrderRequest) => {
  const orderItemsBase = {
    uuid: orderItem.item.uuid,
  }

  const childrenItems = orderItem.children?.items
    ?.map((item) => {
      return {
        uuid: item.item.uuid,
        current: item?.current ?? orderItem?.current,
      }
    })
    .filter(Boolean)

  const orderItemsWithChildren = childrenItems?.length > 0
    ? { ...orderItemsBase, children: childrenItems }
    : orderItemsBase

  if (orderItem.item.type === 'BOOL') {
    if (orderItem.is_used === true) {
      return { ...orderItemsWithChildren, current: 1, is_used: true }
    }
    return null
  }

  const current = orderItem.children?.items?.length > 0
    ? orderItem.children.items.length
    : orderItem.current

  const relatedProduct = orderItem.related_product ? {
    uuid: orderItem.related_product.uuid,
    support_level: orderItem.related_product.support_level,
    items: orderItem.related_product.items?.map((item) => ({
      index: item.index,
      current: item.current
    })) ?? []
  } : undefined

  const result = {
    ...orderItemsWithChildren,
    current: current,
    related_product: relatedProduct
  }

  return result

}

export const formatItems = (products: any[] | undefined): IItemOrderRequest[] => {
  return products?.map((item: IItem) => ({
    item: item,
    current: item.min,
    is_used: item.type === 'BOOL' ? false : undefined,
  }))
}

